import { tryFind, add, empty } from "./fable_modules/fable-library-js.4.28.0/Map.js";
import { int32ToString, comparePrimitives } from "./fable_modules/fable-library-js.4.28.0/Util.js";
import { fold } from "./fable_modules/fable-library-js.4.28.0/Array.js";
import { isEmpty, item, length } from "./fable_modules/fable-library-js.4.28.0/List.js";
import { replace } from "./fable_modules/fable-library-js.4.28.0/String.js";

let translations = empty({
    Compare: comparePrimitives,
});

/**
 * Initialize translations from a JS object fetched at startup.
 */
export function init(json) {
    const keys = Object.keys(json);
    translations = fold((acc, key) => add(key, json[key], acc), empty({
        Compare: comparePrimitives,
    }), keys);
}

/**
 * Translate a key with no parameters. Returns the key itself if missing.
 */
export function t(key) {
    const matchValue = tryFind(key, translations);
    if (matchValue == null) {
        return key;
    }
    else {
        return matchValue;
    }
}

/**
 * Translate a parameterized key (tuple of key + args list).
 * Substitutes {0}, {1}, ... with provided arguments.
 * Returns the key itself if translation is missing.
 */
export function ta(keyAndArgs_, keyAndArgs__1) {
    const keyAndArgs = [keyAndArgs_, keyAndArgs__1];
    const key = keyAndArgs[0];
    const args = keyAndArgs[1];
    const matchValue = tryFind(key, translations);
    if (matchValue == null) {
        return key;
    }
    else {
        let result = matchValue;
        for (let i = 0; i <= (length(args) - 1); i++) {
            result = replace(result, ("{" + int32ToString(i)) + "}", item(i, args));
        }
        return result;
    }
}

/**
 * Translate a TrKey (key + args). Uses `t` for simple keys, `ta` for parameterized.
 */
export function trKey(trk) {
    const key = trk.fields[0];
    const args = trk.fields[1];
    if (isEmpty(args)) {
        return t(key);
    }
    else {
        return ta(key, args);
    }
}

/**
 * Format an ISO date string (e.g. "2026-06-10") using the current UI language locale.
 */
export function formatDate(isoDate) {
    const lang = localStorage.getItem('lang') || 'en';
    return new Date(isoDate + 'T00:00:00').toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' });
}

